import { z } from 'zod';

/** Valeurs de la popin bloquante de saisie du numéro de mobile. */
export interface BlockingPhoneValues {
    tel_mobile: string;
    password: string;
}

const MOBILE_PATTERN = /^(?:(?:\+|00)33|0)\s*[6-7](?:[\s.-]*\d{2}){4}$/;

export const blockingPhoneSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    if (!v['tel_mobile']) {
        errors['tel_mobile'] = 'Le champ est obligatoire';
    } else if (!MOBILE_PATTERN.test(String(v['tel_mobile']))) {
        errors['tel_mobile'] = 'Le numéro de téléphone mobile saisi est invalide';
    }

    if (!v['password']) {
        errors['password'] = 'Le champ est obligatoire';
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
